import React from "react";
import _ from "lodash";

import SettingsProfileV2 from "../../components/StepContent/components/step/EsgProfile/SettingsProfile/SettingsProfileV2";
import SelectProfileV2 from "../../components/StepContent/components/step/EsgProfile/SelectProfile/SelectProfileV2";
import SummaryV2 from "../../components/StepContent/components/step/EsgProfile/SummaryV2";
import DisclaimerTextV2 from "../StepContent/components/step/EsgProfile/DisclaimerText/DisclaimerTextV2";

const ASPECTS_REQUIRED_MSG = 'Bitte wählen Sie mindestens ein Kriterium aus.';

const isPercentValid = function(percentQuestion, step) {
  percentQuestion.error = null;
  if(!percentQuestion.answer && !_.isEmpty(_.get(step.question.find(q => q.uid === "aspects"), 'answer'))){
    percentQuestion.error = 'Bitte wählen Sie eine Prozentzahl die größer als 0 ist.';
  }

  return !percentQuestion.error;
};

const step1 = {
  "uid": "esg-profile-selection-step",
  "name": "Bitte wählen Sie das Nachhaltigkeitsprofil",
  "info_text": <DisclaimerTextV2 />,
  "category": "Auswahl",
  "behaviour": ["dynamic"],
  "step_content": SelectProfileV2,
  "noSkipBtn": true,
  "no_user_input": true,  // disable unsaved changes check as not relevant here
  "question": [
    {
      "uid": "esg-advisor-type",
      "type": "normal",
      "behaviour": ["radio"],
      "optional": true,
      "hidden": true,
      "options": [
        {
          "id": 1,
          "value": "yes",
          "label": "Ja, ich möchte ein ESG Profil anlegen"
        },
        {
          "id": 2,
          "value": "no",
          "label": "Nein, ich möchte kein ESG Profil anlegen",
        }
      ],
      "afterChangeCallback": function (service) {
        service.setEsgProfileSteps();
      }
    },
    {
      "uid": "esg-profile-radio-uid",
      "type": "normal",
      "behaviour": ["radio_cards"],
      "row": true,
      "size": 8,
      "custom_classes": {'labelRoot': 'bold'},
      "optional": true,
      "required_check": true,
      "options": [
        {
          "id": 1,
          "value": "new",
          "label": "Neues Nachhaltigkeitsprofil anlegen"
        },
        {
          "id": 2,
          "value": "not-interested",
          "label": "Der Kunde/die Kundin wünscht keine Nachhaltigkeitsprofilierung",
        },
        {
          "id": 4,
          "value": "prefill",
          "label": "Bereits durchgeführte Nachhaltigkeitsprofilierung auswählen",
        },
      ],
      "afterChangeCallback": function (service) {
        service.setEsgProfileSteps();
      }
    },
    {
      "uid": "esg-profile-select-uid",
      "question_text": "Nachhaltigkeitsprofilierung",
      "type": "normal",
      "behaviour": ["select"],
      "optional": true,
    },
  ],
};

const ESG_PERCENTAGE_QUESTION = 'Wieviel Prozent des Kundenportfolios sollten mindestens diese Vorgabe erfüllen?';
const ESG_GROUP = "Gewichtung der Nachhaltigkeit";
const step3 = {
  "uid": "ecologically-sustainable",
  "name": "Wie wichtig ist Ihrem Kunden/Ihrer Kundin Nachhaltigkeit?",
  "step_content": SettingsProfileV2,
  "parent": ESG_GROUP,
  "category": "Ökologisch nachhaltig",
  "behaviour": ["dynamic"],
  "question": [
    {
      "uid": "percent",
      "type": "normal",
      "behaviour": ["slider"],
      "question_text": ESG_PERCENTAGE_QUESTION,
      "optional": false,
      "answer": 0, // default value
      "isValid": function(step, afterChange, service){
        return isPercentValid(this, step)
      },
    },
    {
      "uid": "aspects",
      "type": "permission",
      "behaviour": ["checkbox_list"],
      "question_text": "Welche Aspekte möchte Ihr Kunde/Ihre Kundin gezielt unterstützen?",
      "question_info":
        "Filter die hier ausgewählt sind, werden später in der Übersicht der Produktauswahl berücksichtigt und entsprechende Produkte werden gekennzeichnet.",
      "optional": true,
      "requiredMsg": ASPECTS_REQUIRED_MSG,
      "config": {
        "choices": [
          {
            "uid": 1,
            "text": "Klimaschutz",
            "info": "Eine Wirtschaftstätigkeit wird als Beitrag zum Klimaschutz eingestuft, wenn sie dazu beiträgt, die Treibhausgaskonzentrationen zu stabilisieren und das langfristige Temperaturziel des Pariser Abkommens zu erreichen. Dies umfasst:\n" +
              "\n" +
              "a) Nutzung und Verbreitung erneuerbarer Energien,\n" +
              "\n" +
              "b) Steigerung der Energieeffizienz, \n" +
              "\n" +
              "c) Ausbau klimaneutraler Mobilität, \n" +
              "\n" +
              "d) Nutzung nachhaltiger Materialien, \n" +
              "\n" +
              "e) Einsatz von CO2-Abscheidung und -Speicherungstechnologien, \n" +
              "\n" +
              "f) Stärkung von CO2-Senken durch nachhaltige Landbewirtschaftung, \n" +
              "\n" +
              "g) Aufbau einer dekarbonisierungsfähigen Energieinfrastruktur, \n" +
              "\n" +
              "h) Produktion sauberer und effizienter Kraftstoffe."
          },
          {
            "uid": 2,
            "text": "Anpassung an den Klimawandel",
            "info": "Eine Wirtschaftstätigkeit wird als wesentlicher Beitrag zur Anpassung an den Klimawandel eingestuft, wenn sie:\n" +
              "\n" +
              "a) Anpassungslösungen umfasst, die das Risiko nachteiliger Klimafolgen für die Wirtschaftstätigkeit selbst oder für Menschen, Natur oder Vermögenswerte erheblich verringern, ohne neue Risiken zu schaffen; oder\n" +
              "\n" +
              "b) Anpassungslösungen bietet, die das Risiko nachteiliger Klimafolgen für Menschen, Natur oder Vermögenswerte erheblich verringern und die Anforderungen des Artikels 16 erfüllen, ohne neue Risiken zu schaffen."
          },
          {
            "uid": 3,
            "text": "Nachhaltige Nutzung und Schutz von Wasser- und Meeresressourcen",
            "info": "Eine Wirtschaftstätigkeit trägt zur nachhaltigen Nutzung und zum Schutz von Wasser- und Meeresressourcen bei, wenn sie entweder wesentlich zur Erreichung oder Erhaltung des guten Zustands von Gewässern beiträgt, einschließlich Oberflächenwasser, Grundwasser und Meeresgewässern, durch:\n" +
              "\n" +
              "a) Schutz der Umwelt vor schädlichen Auswirkungen von städtischem und industriellem Abwasser, einschließlich Kontaminanten wie Arzneimitteln und Mikroplastik, durch angemessene Sammlung, Behandlung und Entsorgung;\n" +
              "\n" +
              "b) Schutz der menschlichen Gesundheit vor Verunreinigungen im Trinkwasser, indem sichergestellt wird, dass das Wasser frei von schädlichen Mikroorganismen, Parasiten und Stoffen ist, und der Zugang zu sauberem Trinkwasser, insbesondere für benachteiligte Gruppen, verbessert wird;\n" +
              "\n" +
              "c) Verbesserung der Wasserbewirtschaftung und Wassereffizienz, Schutz und Verbesserung aquatischer Ökosysteme, nachhaltige Nutzung von Wasserressourcen, Verringerung von Schadstoffemissionen, und Reduktion der Auswirkungen von Überschwemmungen und Dürren;\n" +
              "\n" +
              "d) Gewährleistung der nachhaltigen Nutzung mariner Ökosysteme, Beitrag zum guten Umweltzustand von Meeresgewässern durch Schutz, Erhaltung oder Wiederherstellung der Meeresumwelt und Verringerung von Schadstoffeinträgen."
          },
          {
            "uid": 4,
            "text": "Übergang zu einer Kreislaufwirtschaft",
            "info": "Eine Wirtschaftstätigkeit leistet einen wesentlichen Beitrag zum Übergang zu einer Kreislaufwirtschaft, wenn sie:\n" +
              "\n" +
              "a) natürliche Ressourcen effizienter nutzt durch: i. reduzierten Einsatz von Primärrohstoffen oder erhöhte Nutzung von Neben- und Sekundärrohstoffen; ii. Ressourcen- und Energieeffizienzmaßnahmen;\n" +
              "\n" +
              "b) die Haltbarkeit, Reparaturfähigkeit, Nachrüstbarkeit oder Wiederverwendbarkeit von Produkten verbessert;\n" +
              "\n" +
              "c) die Recyclingfähigkeit von Produkten und deren Materialien verbessert, durch Ersetzung oder begrenzte Nutzung nicht wiederverwendbarer Produkte;\n" +
              "\n" +
              "d) den Einsatz gefährlicher Stoffe reduziert und diese durch sicherere Alternativen ersetzt, während die Rückverfolgbarkeit gewährleistet wird;\n" +
              "\n" +
              "e) die Nutzung von Produkten durch Wiederverwendung, langlebiges Design, Umfunktionierung, Demontage, Wiederaufarbeitung, Modernisierung, Reparatur und gemeinsame Nutzung verlängert;\n" +
              "\n" +
              "f) verstärkt Sekundärrohstoffe nutzt und deren Qualität durch hochwertiges Recycling von Abfällen steigert;\n" +
              "\n" +
              "g) die Abfallerzeugung, insbesondere bei der Gewinnung von Mineralien sowie beim Bau und Abriss von Gebäuden, vermeidet oder verringert.\n" +
              "\n" +
              "h) die Vorbereitung zur Wiederverwendung und das Recycling von Abfällen verstärkt;\n" +
              "\n" +
              "i) die Abfallbewirtschaftungsinfrastruktur ausbaut, um Vermeidung, Wiederverwendung und Recycling zu unterstützen, und hochwertige Sekundärrohstoffe für die Produktion sicherstellt;\n" +
              "\n" +
              "j) die Abfallverbrennung verringert und die Abfallbeseitigung, einschließlich Deponierung, vermeidet, gemäß der Abfallhierarchie;\n" +
              "\n" +
              "k) Abfall vermeidet oder verringert."
          },
          {
            "uid": 5,
            "text": "Vermeidung und Verminderung der Umweltverschmutzung",
            "info": "Eine Wirtschaftstätigkeit leistet einen wesentlichen Beitrag zur Vermeidung und Verminderung der Umweltverschmutzung, wenn sie:  \n" +
              "\n" +
              "a) Emissionen (außer Treibhausgase) in Luft, Wasser oder Boden vermeidet oder verringert;\n" +
              "\n" +
              "b) die Luft-, Wasser- oder Bodenqualität in den betroffenen Gebieten verbessert und gleichzeitig nachteilige Auswirkungen auf die menschliche Gesundheit und die Umwelt minimiert;\n" +
              "\n" +
              "c) nachteilige Auswirkungen auf die menschliche Gesundheit und die Umwelt bei der Herstellung, Verwendung oder Beseitigung von Chemikalien vermeidet oder minimiert;\n" +
              "\n" +
              "d) Abfälle und sonstige Schadstoffe beseitigt."
          },
          {
            "id": 6,
            "uid": 6,
            "text": "Schutz und Wiederherstellung der Biodiversität und der Ökosysteme",
            "info": "Eine Wirtschaftstätigkeit leistet einen wesentlichen Beitrag zum Schutz und zur Wiederherstellung der Biodiversität und der Ökosysteme, wenn sie durch Folgendes wesentlich zum Schutz, zur Erhaltung oder zur Wiederherstellung der Biodiversität oder zur Erreichung des guten Zustands von Ökosystemen beiträgt: \n" +
              "\n" +
              "a) Erhaltung der Natur und Biodiversität, einschließlich der Erreichung oder Erhaltung eines günstigen Erhaltungszustands von Lebensräumen und Arten sowie Schutz und Wiederherstellung von terrestrischen, marinen und aquatischen Ökosystemen zur Verbesserung ihres Zustands und ihrer Fähigkeit zur Erbringung von Ökosystemdienstleistungen;\n" +
              "\n" +
              "b) nachhaltige Landnutzung und -bewirtschaftung, einschließlich Schutz der Biodiversität in Böden, Neutralität gegenüber Landdegradation und Sanierung belasteter Standorte;\n" +
              "\n" +
              "c) nachhaltige landwirtschaftliche Verfahren zur Förderung der Biodiversität und Verhinderung von Bodendegradation, Entwaldung und Verlust von Lebensräumen;\n" +
              "\n" +
              "d) nachhaltige Waldbewirtschaftung zur Förderung der Biodiversität und Verhinderung der Degradation von Ökosystemen, Entwaldung und Verlust von Lebensräumen."
          },
        ],
      },
    },
  ],
};

const step4 = {
  "uid": "esg",
  "name": "Wie wichtig ist Ihrem Kunden/Ihrer Kundin Nachhaltigkeit?",
  "parent": ESG_GROUP,
  "category": "ESG",
  "behaviour": ["dynamic"],
  step_content: SettingsProfileV2,
  "question": [
    {
      "uid": "percent",
      "type": "normal",
      "behaviour": ["slider"],
      "question_text": ESG_PERCENTAGE_QUESTION,
      "question_info":
        "(Umwelt-, Sozial- und Unternehmensführung ) Fokus ist Gewissenhaftigkeit eines Unternehmens für soziale und ökologische Faktoren.",
      "optional": false,
      "answer": 0, // default value
      "isValid": function(step, afterChange, service){
        return isPercentValid(this, step)
      },
    },
    {
      "uid": "aspects",
      "type": "permission",
      "behaviour": ["checkbox_list"],
      "question_text": "Welche Aspekte möchte Ihr Kunde/Ihre Kundin gezielt unterstützen?",
      "question_info":
        "Filter die hier ausgewählt sind, werden später in der Übersicht der Produktauswahl berücksichtigt und entsprechende Produkte werden gekennzeichnet.",
      "optional": true,
      "requiredMsg": ASPECTS_REQUIRED_MSG,
      "config": {
        "choices": [
          {
            "uid": 1,
            "text": "Ökologische Kriterien",
            "info": "Investition in eine wirtschaftliche Tätigkeit, die zur Erreichung eines Umweltziels beiträgt.",
          },
          {
            "uid": 2,
            "text": "Soziale Kriterien",
            "info": "Investition in eine wirtschaftliche Tätigkeit, die zur Erreichung eines sozialen Ziels beiträgt."
          },
          {
            "uid": 3,
            "text": "Verfahrensweisen einer guten Unternehmensführung",
            "info": "Investition in Humankapital oder zugunsten wirtschaftlich oder sozial benachteiligter " +
              "Bevölkerungsgruppen, vorausgesetzt, dass diese Investitionen keines dieser Ziele erheblich " +
              "beeinträchtigen und die Unternehmen, in die investiert wird, Verfahrensweisen einer guten Unternehmensführung anwenden."
          },
        ],
      },
    },
  ],
};

const step5 = {
  "uid": "pai",
  "name": "Wie wichtig ist Ihrem Kunden/Ihrer Kundin Nachhaltigkeit?",
  "parent": ESG_GROUP,
  "category": "PAI",
  "behaviour": ["dynamic"],
  "step_content": SettingsProfileV2,
  "question": [
    {
      "uid": "percent",
      "type": "normal",
      "behaviour": ["slider"],
      "question_text": ESG_PERCENTAGE_QUESTION,
      "question_info":
        "(Umwelt-, Sozial- und Unternehmensführung ) Fokus ist Gewissenhaftigkeit eines Unternehmens für soziale und ökologische Faktoren.",
      "optional": false,
      "answer": 0, // default value
      "isValid": function(step, afterChange, service){
        return isPercentValid(this, step)
      },
    },
    {
      "uid": "aspects",
      "type": "permission",
      "behaviour": ["checkbox_list"],
      "question_text": "Das Finanzinstrument soll folgende PAI-Themen berücksichtigen.",
      "question_info":
        "Filter die hier ausgewählt sind, werden später in der Übersicht der Produktauswahl berücksichtigt und entsprechende Produkte werden gekennzeichnet.",
      "optional": true,
      "requiredMsg": ASPECTS_REQUIRED_MSG,
      "config": {
        "choices": [
          {
            "uid": 1,
            "text": "Treibhausgas-Emissionen",
            "info": "<b>Treibhausgasemissionen (THG):</b> Gase wie CO₂, die zur Erderwärmung beitragen.\n" +
              "\n" +
              "<b>CO₂-Fußabdruck:</b> Gesamtmenge an durch Menschen verursachtem CO₂.\n" +
              "\n" +
              "<b>THG-Emissionsintensität:</b> Treibhausgase pro wirtschaftliche Aktivität eines Unternehmens.\n" +
              "\n" +
              "<b>Engagement in fossile Brennstoffe:</b> Investitionen in Kohle-, Öl- und Gasunternehmen.\n" +
              "<b>Anteil nicht erneuerbarer Energie:</b> Energieverbrauch aus Kohle, Öl und Gas.\n" +
              "\n" +
              "<b>Energieverbrauch in klimaintensiven Sektoren:</b> Energieverbrauch in Sektoren mit hohen Emissionen, z.B. Industrie und Transport."
          },
          {
            "uid": 2,
            "text": "Biodiversität",
            "info": "Tätigkeiten, die sich nachteilig auf Gebiete mit schutzbedürftiger Biodiversität auswirken."
          },
          {
            "uid": 3,
            "text": "Wasser",
            "info": "Emissionen in Wasser"
          },
          {
            "uid": 4,
            "text": "Abfall",
            "info": "Anteil gefährlicher und radioaktiver Abfälle"
          },
          {
            "uid": 5,
            "text": "Soziale Themen und Arbeitnehmerbelange, Korruption und Menschenrechte",
            "info": "<b>Verstöße gegen UNGC-Grundsätze und OECD-Leitsätze:</b> Verletzungen der Prinzipien des UN Global Compact und der OECD-Leitsätze für multinationale Unternehmen.\n" +
              "\n" +
              "<b>Fehlende Compliance-Mechanismen:</b> Mangel an Prozessen und Mechanismen zur Überwachung der Einhaltung der UNGC-Grundsätze und OECD-Leitsätze.\n" +
              "\n" +
              "<b>Geschlechtsspezifisches Verdienstgefälle:</b> Unterschiede im Einkommen zwischen Männern und Frauen.\n" +
              "\n" +
              "<b>Geschlechtervielfalt in Führungspositionen:</b> Anteil von Frauen in Leitungs- und Kontrollorganen.\n" +
              "\n" +
              "<b>Engagement in umstrittenen Waffen:</b> Beteiligung an der Produktion oder Verbreitung von Antipersonenminen, Streumunition sowie chemischen und biologischen Waffen."
          },
          {
            "uid": 6,
            "text": "Indikatoren bei Investments in staatliche und supranationale Emittenten",
            "info": "<b>THG-Emissionsintensität:</b> Treibhausgase pro wirtschaftliche Aktivität eines Unternehmens.\n" +
              "\n" +
              "<b>Länder mit sozialen Verstößen:</b> Investitionen in Länder, die gegen soziale Bestimmungen verstoßen."
          },
          {
            "uid": 7,
            "text": "Indikatoren bei Investments in Immobilienvermögen",
            "info": "<b>Engagement in fossilen Brennstoffen durch Immobilieninvestitionen:</b> Investitionen in Immobilien, die mit fossilen Brennstoffen betrieben werden oder deren Nutzung fördern.\n" +
              "\n" +
              "<b>Investitionen in ineffiziente Immobilien:</b> Engagement in Immobilien mit schlechter Energieeffizienz, die zu hohem Energieverbrauch und höheren Emissionen führen."
          },
        ],
      },
    },
  ],
};

const step6 = {
  "uid": "summary",
  "category": "Nachhaltigkeitsprofil",
  "behaviour": ["dynamic"],
  "name": "Nachhaltigkeitsprofil von {customer_name}",
  "withUserName": true,
  step_content: SummaryV2,
  "question": [
    {
      "uid": "esg",
      "question_text":
        "Ihr Kundenportfolio soll idealerweise diese Vorgabe erfüllen",
      "question_info":
        "Diese Filter sind in der Übersicht der Produktauswahl berücksichtigt und entsprechende Produkte werden gekennzeichnet.",
      "type": "normal",
      "behaviour": ["radio"],
      "optional": true,
    },
    {
      "uid": "pai",
      "question_text":
        "Nachhaltigkeitsprofil des Kunden",
      "question_info":
        "Ihr Kunde möchte in nachhaltige Produkte investieren.",
      "type": "normal",
      "behaviour": ["radio"],
      "optional": true,
    },
    {
      "uid": "ecologically-sustainable",
      "question_text":
        "Nachhaltigkeitsprofil des Kunden",
      "question_info":
        "Ihr Kunde möchte in nachhaltige Produkte investieren.",
      "type": "normal",
      "behaviour": ["radio"],
      "optional": true,
    },
  ],
};

export const esgProfileStepsDataV2 = {
  steps: [step1, step3, step4, step5, step6],
};